let likedDrinks = 0;
const totalLikesToMatch = 11;
let currentDrinkIndex = 0;
let currentDrinkImage = ""; // Armazena a URL da imagem da bebida atual

// Lista de bebidas
const drinks = [
    {
        name: "Colorado",
        description: "Colorado é o cara que valoriza a autenticidade e a tradição, com uma personalidade forte e um toque rústico. Ele é aventureiro e aprecia os detalhes únicos de cada experiência. Seu estilo é natural e marcante, sendo a companhia perfeita para quem busca algo original e genuíno.",
        image: "https://i.pinimg.com/736x/0a/3c/3c/0a3c3cdacd38f0affe21f00131b00fb8.jpg"
    },  
    {
        name: "Bohemia",
        description: "Bohemia é a garota que traz um toque de sofisticação e liberdade. Com um estilo elegante e um espírito livre, ela cativa pela sua atitude descontraída e charme natural. Sempre à procura de novas experiências, ela é a companhia ideal para momentos de aventura e descoberta.",
        image: "https://i.pinimg.com/736x/3b/d3/cb/3bd3cb420996df9dbaad95ab7370a5bf.jpg"
    },
    {
        name: "Amstel",
        description: "Amstel é o cara tranquilo e de mente aberta, com uma personalidade amigável e fácil de lidar. Seu estilo é simples, mas com um toque internacional, refletindo seu gosto por novas culturas e experiências. Ele é a companhia ideal para conversas agradáveis e momentos descontraídos.",
        image: "https://i.pinimg.com/736x/2e/ee/a5/2eeea5980996a93639ac97a84b368e0f.jpg"
    },
    {
        name: "Chandon",
        description: "Chandon é o homem sofisticado e charmoso, com uma personalidade elegante e um estilo requintado. Ele é conhecido por sua presença marcante e por saber aproveitar os melhores momentos da vida com classe e descontração. Sempre pronto para uma celebração, ele traz um toque de glamour e alegria a qualquer ocasião.",
        image: "https://i.pinimg.com/736x/8b/70/e3/8b70e336f7e163323e4853c999d20a52.jpg"
    },
    {
        name: "Heineken",
        description: "Heineken é a garota sofisticada e internacional, conhecida por seu charme universal e estilo refinado. Sempre elegante e confiante, ela é a amiga que traz um toque de classe e energia a qualquer ocasião. Sua presença é sempre marcante e memorável.",
        image: "https://i.pinimg.com/736x/f8/b9/eb/f8b9ebb2dd74c39e53f48c62846771f2.jpg"
    },
    {
        name: "Crystal",
        description: "Crystal é o cara simples e transparente, com uma personalidade leve e acessível. Seu estilo é descomplicado e prático, sempre trazendo uma sensação de tranquilidade e honestidade. Ele é o tipo de pessoa com quem você pode contar, a companhia ideal para momentos descontraídos e autênticos",
        image: "https://i.pinimg.com/474x/ab/03/2c/ab032cec7521328bde5fdc0b9a3e52c1.jpg"
    },

    {
        name: "Budweeiser",
        description: "Budweiser é a garota amigável e descontraída, sempre pronta para uma boa conversa e diversão. Com um jeito acessível e um estilo clássico, ela é a companhia ideal para momentos descontraídos e encontros casuais. Sua energia é contagiante e sempre acolhedora.",
        image: "https://i.pinimg.com/736x/e3/1e/f9/e31ef90ef543e78998e22965ceb328f6.jpg"
    },
    {
        name: "Lokal",
        description: "Lokal é o cara descontraído e autêntico, com uma personalidade acolhedora e um estilo casual. Ele é o tipo de pessoa que faz qualquer lugar se sentir como casa, trazendo um senso de familiaridade e simplicidade. Sempre pronto para uma boa conversa e momentos relaxantes, ele é a companhia ideal para encontros descontraídos.",
        image: "https://i.pinimg.com/736x/e8/16/e3/e816e31a264a3276f5c40cde650dffb4.jpg"
    },
    {
        name: "Spaten",
        description: "Spaten é a garota refinada e sofisticada, com um toque de tradição e elegância. Seu estilo clássico e atitude confiante fazem dela a companhia ideal para eventos requintados e conversas profundas, sempre trazendo uma sensação de distinção e charme.",
        image: "https://i.pinimg.com/736x/11/d5/33/11d53396d28af233456c034d429f046b.jpg"
    },
    {
        name: "Skol",
        description: "Skol é o cara robusto e destemido, com um espírito aventureiro e uma presença imponente. Seu estilo é inspirado na tradição e força dos vikings, refletindo uma personalidade corajosa e leal. Sempre pronto para desafios e com uma atitude de bravura, ele é a companhia ideal para momentos épicos e grandes aventuras.",
        image: "https://i.pinimg.com/736x/19/36/60/1936608eaccd69796370ee745d171b2a.jpg"
    },
    {
        name: "Black Princess",
        description: "Black Princess é a mulher elegante e enigmática, com um charme sofisticado e uma presença impressionante. Seu estilo é refinado e sua atitude, de mistério e graça, a torna irresistível. Ela é a companhia perfeita para quem busca um toque de requinte e uma aura de exclusividade.",
        image: "https://i.pinimg.com/736x/7a/2b/d5/7a2bd5a62b549ba64e229ddfc99d2e92.jpg"
    },
    {
        name: "Devassa",
        description: "Devassa é a mulher ousada e provocante, com uma personalidade marcante e cheia de atitude. Seu estilo é audacioso e sedutor, sempre atraindo olhares por onde passa. Ela adora quebrar regras e trazer uma energia intensa para qualquer ocasião, sendo a companhia perfeita para quem busca diversão e aventura sem limites.",
        image: "https://i.pinimg.com/736x/16/6f/d8/166fd86f6d074255da4939415fa9d313.jpg"
    },
    {
        name: "Kaiser",
        description: "Kaiser é a mulher determinada e confiante, com uma personalidade forte e um estilo direto. Ela não tem medo de assumir o controle e sempre busca o melhor em tudo o que faz. Com uma presença marcante e atitude firme, ela é a companhia ideal para quem aprecia força e independência.",
        image: "https://i.pinimg.com/736x/f1/2f/2d/f12f2d84115830ee6c1904e659c2430a.jpg"
    },
    {
        name: "Café",
        description: "Café é o cara sofisticado e intelectual, com uma personalidade madura e um estilo clássico. Ele é o tipo que aprecia conversas profundas e momentos de reflexão, sempre trazendo um toque de elegância e discernimento. Ideal para quem busca uma companhia inteligente e cheia de charme.",
        image: "https://i.pinimg.com/736x/06/54/45/065445367dd3022a6e50c45dcdee075d.jpg"
    },
    {
        name: "Brahma",
        description: "Brahma é a garota carismática e confiável, sempre animando qualquer evento com seu sorriso acolhedor e estilo descomplicado. Ela faz com que todos se sintam à vontade e prontos para aproveitar o momento.",
        image: "https://i.pinimg.com/736x/16/5a/7a/165a7ae9d55605801950720c8a879888.jpg"
    },
    {
        name: "Coca-cola",
        description: "Coca-Cola é a mulher vibrante e cheia de energia, com uma personalidade cativante e um estilo clássico. Ela traz um senso de alegria e diversão a qualquer ocasião, sempre com um sorriso no rosto. Sua presença é refrescante e envolvente, tornando-a a companhia perfeita para momentos animados e descontraídos.",
        image: "https://i.pinimg.com/736x/9a/96/3e/9a963e14fa56c450616d76738af47c25.jpg"
    },
    {
        name: "Itaipava",
        description: "Itaipava é a garota animada e vibrante, com uma personalidade cheia de energia e entusiasmo. Com seu estilo jovem e moderno, ela traz uma sensação refrescante a qualquer encontro, sempre pronta para criar memórias divertidas e inesquecíveis.",
        image: "https://i.pinimg.com/736x/59/ee/52/59ee5233ef2522b27a1bc30b36cdaece.jpg"
    },
    {
        name: "Red Bull",
        description: "Red Bull é a pessoa dinâmica e cheia de energia, com uma personalidade arrojada e um estilo ousado. Sempre pronta para enfrentar desafios e buscar novas aventuras, ela traz uma dose extra de entusiasmo e vitalidade a qualquer situação. Ideal para quem busca uma companhia estimulante e sempre disposta a ir além dos limites.",
        image: "https://i.pinimg.com/736x/f3/ae/2e/f3ae2e435a02c8520eab22f80ed9c447.jpg"
    },
    {
        name: "Reservado Tinto",
        description: "Reservado Tinto é o homem sofisticado e refinado, com um gosto apurado e uma presença marcante. Seu estilo é elegante e clássico, refletindo uma personalidade de distinção e sabedoria. Ele é a companhia ideal para momentos de celebração e para conversas profundas, sempre trazendo um toque de classe e sofisticação.",
        image: "https://i.pinimg.com/736x/4e/09/da/4e09da891516d0a138e6fede707deeea.jpg"
    },
    {
        name: "Imperio",
        description: "Império é o cara com uma presença marcante e uma aura de confiança. Seu estilo é imponente e sofisticado, refletindo uma personalidade de liderança e influência. Sempre atento aos detalhes e com um charme inconfundível, ele é a companhia perfeita para ocasiões que exigem um toque de classe e autoridade.",
        image: "https://i.pinimg.com/736x/06/a0/17/06a017596ed77772f96e9d420be3f677.jpg"
    },
    {
        name: "Corona",
        description: "Corona é o cara descolado e aventureiro, com uma personalidade vibrante e uma paixão por novas experiências. Seu estilo é casual e moderno, refletindo seu espírito ousado e energético. Sempre pronto para um desafio, ele é a companhia ideal para quem busca algo único e emocionante.",
        image: "https://i.pinimg.com/736x/d5/31/43/d53143631423d1c79f5a0cd43ebf27e6.jpg"
    },  
    {
        name: "Antartica",
        description: "Antártica é a garota que combina frescor e originalidade. Com seu estilo único e descontraído, ela se destaca pela autenticidade e charme. Sempre trazendo uma brisa de novidade e diversão, ela é a companhia perfeita para quem busca algo diferente e refrescante.",
        image: "https://i.pinimg.com/736x/49/bf/36/49bf36f76054be8ea3b44d7e3670593b.jpg"
    },
    
  
    // Adicione mais bebidas conforme necessário
];

// Lista de frases neutras
const frasesNeutras = [
    "Ei, tô te esperando no WhatsApp! 😉",
    "Vem trocar uma ideia comigo! 😄",
    "Acho que combinamos! O que acha? 😎",
    "Clica no gostei e me chama no zap! 💬",
    "Sinto que vai dar match! 🔥",
    "Pronto para o match? Me chama no zap 2499798893! ❤️",
    "Gostou de mim? Bora conversar! 😍",
    "Vamos bater um papo? Estou esperando no WhatsApp! 📲",
    "Clique no gostei e venha conversar comigo! 😊",
    "Acredito que temos uma conexão! O que pensa? 🤔",
    "Dê um like e me envie uma mensagem no insta @opbdelivery! 💌",
    "Sinto que a gente vai se dar bem! 🚀",
    "Preparado para conversar? Me chame no zap 24992798893! 💬",
    "Curtiu? Vamos trocar ideias! 🌟",
    "Gostou do que viu? Venha conversar comigo! 😃",
    "Vamos descobrir se rolou match! Me mande uma mensagem @opbdelivery! 📩",
    "Se sentiu a conexão? Clique em gostei e me procure! 😉"
];

// Função para exibir a próxima bebida e frase neutra
function mostrarProximaBebida() {
    const drinkCard = document.getElementById("drink-card");
    const drink = drinks[currentDrinkIndex];

    // Exibe frase neutra aleatória no balão de fala
    const falaBaloon = document.getElementById("fala-baloon");
    falaBaloon.style.display = "block"; // Garante que o balão seja exibido
    falaBaloon.textContent = frasesNeutras[Math.floor(Math.random() * frasesNeutras.length)];

    drinkCard.querySelector("img").src = drink.image;
    drinkCard.querySelector("h2").textContent = drink.name;
    drinkCard.querySelector("p").textContent = drink.description;

    currentDrinkImage = drink.image; // Armazena a imagem da bebida atual

    drinkCard.style.display = "block";

    // Avança para a próxima bebida (loop infinito)
    currentDrinkIndex = (currentDrinkIndex + 1) % drinks.length;
}

// Função chamada quando o usuário desliza para a direita (gostei)
function swipeRight() {
    likedDrinks++;

    if (likedDrinks === totalLikesToMatch) {
        mostrarMatch();
    } else {
        mostrarProximaBebida();
    }
}

// Função chamada quando o usuário desliza para a esquerda (não gostei)
function swipeLeft() {
    mostrarProximaBebida();
}

// Mostra a tela de match final com o cupom e link para WhatsApp
function mostrarMatch() {
    const randomCoupons = ["OPB5OFF", "OPBFRT0800", "OPB5CBACK"];
    const selectedCoupon = randomCoupons[Math.floor(Math.random() * randomCoupons.length)];
    const whatsappMsg = `Demos match ❤️ esse é meu cupom ${selectedCoupon} 🎉`;
    const whatsappLink = `https://wa.me/5524992798893?text=${encodeURIComponent(whatsappMsg)}`;

    document.getElementById("coupon").textContent = selectedCoupon;
    document.getElementById("whatsapp-link").href = whatsappLink;

    // Define a imagem do match como a imagem da bebida atual
    document.getElementById("match-image").src = currentDrinkImage;

    document.getElementById("drink-card").style.display = "none";
    document.getElementById("match").style.display = "block";
    
    criarConfetes(); // Cria o efeito de confetes
}

// Função para criar confetes
function criarConfetes() {
    const quantidadeConfetes = 100;
    const confettiContainer = document.createElement('div');
    confettiContainer.classList.add('confetti');
    document.body.appendChild(confettiContainer);

    for (let i = 0; i < quantidadeConfetes; i++) {
        const confetti = document.createElement('div');
        confetti.classList.add('confetti-piece');
        confetti.style.left = `${Math.random() * 100}vw`;
        confetti.style.top = `${Math.random() * 100}vh`;
        confetti.style.backgroundColor = `hsl(${Math.random() * 360}, 70%, 60%)`;
        confetti.style.animationDelay = `${Math.random() * 2}s`;
        confettiContainer.appendChild(confetti);
    }

    // Remove o container de confetes após a animação
    setTimeout(() => {
        document.body.removeChild(confettiContainer);
    }, 5000); // Tempo de duração da animação
}

// Inicializa a primeira bebida
mostrarProximaBebida();
